import { Component, ViewChild, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MasterService } from '../../master.service';
import { ConfirmationMessageComponent, ConfirmationDialog } from '../../../comman-components/confirmation-message/confirmation-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { WoTypeDialogComponent } from '../wo-type-dialog/wo-type-dialog.component';
import { debounceTime, distinctUntilChanged, map, startWith, Subscription, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';

export interface PeriodicElement {
  position: any;
  woType: any;
  status: any;
  action: any;
}

@Component({
  selector: 'app-wo-type-list',
  templateUrl: './wo-type-list.component.html',
  styleUrls: ['./wo-type-list.component.scss']
})
export class WoTypeListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public displayedColumns = ['position', 'action', 'woType', 'status'];
  public settings: Settings;
  dataSource = new MatTableDataSource<PeriodicElement>();
  totalData: any;
  searchControl = new FormControl('');
  subscription: Subscription;
  isWoTypeSaveInProgress = false;

  constructor(
    public appSettings: AppSettings,
    private masterService: MasterService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    this.settings = this.appSettings.settings; 
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    this.paginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          if (this.searchControl.value !== '') {
            return this.masterService.getWoTypesByPageCount({ page: this.paginator.pageIndex, searchText: this.searchControl.value });  
          }
          return this.masterService.getWoTypesByPageCount({ page: this.paginator.pageIndex });
        }),
        map((res: any) => {
          this.totalData = res.totalData;
          return res.data;
        })
      )
      .subscribe((data: any) => {
        this.dataSource = new MatTableDataSource(data);
      });

    this.subscription = this.searchControl.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.searchWoType(0, value);
      });
  }

  getAllWoType(pageNumber: Number) {
    this.masterService.getWoTypesByPageCount({ page: this.paginator.pageIndex }).subscribe({
      next: (res: any) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
      },
      error: (error) => { }
    });
  }

  searchWoType(pageNumber: Number, search: string) {
    this.masterService.getWoTypesByPageCount({ page: pageNumber, searchText: search }).subscribe({
      next: (res: any) => {
        this.dataSource.data = res?.data;
        this.totalData = res?.totalData;
        this.dataSource.paginator = this.paginator;
      },
      error: (error) => { }
    });
  }

  public createWoTypeDialog(woTypeObj?) {
    if (this.isWoTypeSaveInProgress) {
      return;
    }

    this.isWoTypeSaveInProgress = true;

    let dialogRef = this.dialog.open(WoTypeDialogComponent, {
      panelClass: 'category-dialog-panel',
      width: '400px',
      data: woTypeObj
    });

    dialogRef.afterClosed().subscribe(woTypeObjResult => {
      if (woTypeObjResult) {
        const payload = {
          woTypeName: woTypeObjResult.woTypeName.trim(),
          status: woTypeObjResult.status,
        };

        if (woTypeObjResult.woTypeKey) {
          this.updateWoType(payload, woTypeObjResult.woTypeKey);
        } else {
          this.createWoType(payload);
        }
      } else {
        this.isWoTypeSaveInProgress = false;
      }
    });
  }

  createWoType(payload) {
    this.masterService.addWoType(payload).subscribe(res => {
      if (res) {
        this.snackBar.open('WO Type created successfully', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getAllWoType(0);
      }
      this.isWoTypeSaveInProgress = false;
    }, (error) => {
      this.isWoTypeSaveInProgress = false;
      if (error) {
        this.snackBar.open(error, 'Cancel', {
          duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
        });
      }
    });
  }

  updateWoType(payload, id) {
    this.masterService.updateWoType(id, payload).subscribe(res => {
      if (res) {
        this.snackBar.open('WO Type updated successfully', 'Cancel', {
          duration: 3000, verticalPosition: 'top', panelClass: ['if-success']
        });
        this.getAllWoType(0);
      }
      this.isWoTypeSaveInProgress = false;
    }, (error) => {
      this.isWoTypeSaveInProgress = false;
      if (error) {
        this.snackBar.open(error, 'Cancel', {
          duration: 5000, verticalPosition: 'top', panelClass: ['if-error']
        });
      }
    });
  }

 deleteWoType(id: any): void {
  const data: ConfirmationDialog = {
    title: 'WO Type Delete Confirmation',
    message: 'Do you want to delete WO Type?',
    yes: 'Yes',
    no: 'No'
  };

  const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
    width: '400px',
    height: '200px',
    position: { top: '200px' },
    data: data
  });

  dialogRef.afterClosed().subscribe((result) => {

    if (!result) {
      return;
    }

    console.log('Deleting WO Type ID:', id);

    this.masterService.deleteWoType(id).subscribe({

      next: (res: any) => {

        console.log('Delete response:', res);

        this.snackBar.open(
          'WO Type deleted successfully',
          'Cancel',
          {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['if-success']
          }
        );

        // Reload first page after delete
        this.getAllWoType(0);
      },

      error: (error: any) => {

        console.error('WO Type delete error:', error);

        let errorMessage = 'Unable to delete WO Type';

        if (typeof error === 'string') {
          errorMessage = error;
        }
        else if (error?.error?.message) {
          errorMessage = error.error.message;
        }
        else if (error?.error?.error) {
          errorMessage = error.error.error;
        }
        else if (error?.message) {
          errorMessage = error.message;
        }

        this.snackBar.open(
          errorMessage,
          'Cancel',
          {
            duration: 5000,
            verticalPosition: 'top',
            panelClass: ['if-error']
          }
        );
      }
    });
  });
}

  toggleWoTypeStatus(element: any) {
    const isCurrentlyActive = element.status === 'ACTIVE';
    const data: ConfirmationDialog = {
      title: 'WO Type Status Confirmation',
      message: isCurrentlyActive ? 'Do you want to Deactivate this WO Type?' : 'Do you want to Activate this WO Type?',
      yes: 'Yes',
      no: 'No'
    };

    const dialogRef = this.dialog.open(ConfirmationMessageComponent, {
      width: '400px',
      height: '200px',
      position: { top: '200px' },
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      const payload = {
        woTypeName: element.woTypeName,
        status: isCurrentlyActive ? 'INACTIVE' : 'ACTIVE'
      };

      this.masterService.updateWoType(element.woTypeKey, payload).subscribe(() => {
        element.status = payload.status;
        this.dataSource.data = [...this.dataSource.data];
        this.snackBar.open(
          `WO Type ${payload.status === 'ACTIVE' ? 'Activated' : 'Deactivated'} Successfully`,
          'Cancel',
          { duration: 3000, verticalPosition: 'top', panelClass: ['if-success'] }
        );
      });
    });
  }

  numbersFun(index: number): number {
    return index + 1 + (this.paginator.pageIndex * this.paginator.pageSize);
  }
}